import React, { useState } from 'react';
import Wizard from './Wizard';
import History from './History';
import RunView from './RunView';

// Super Duplicador: copia módulos, submódulos o formatos sueltos dentro de la misma empresa o a
// otra. Tres vistas: el asistente (nueva copia), el historial de corridas y el detalle de una
// corrida (progreso en vivo, log, reporte y deshacer).
const Index = () => {
    const [view, setView] = useState("wizard");
    const [runId, setRunId] = useState(null);
    const [wizardKey, setWizardKey] = useState(0);

    const openRun = (id) => { setRunId(id); setView("run"); };
    const newCopy = () => { setWizardKey((k) => k + 1); setView("wizard"); };

    return (
        <div className="rk-wrap sd">
            <div className="rk-head">
                <div className="rk-head__icon"><i className="fas fa-clone"></i></div>
                <div className="rk-head__text">
                    <h1 className="rk-head__title">Super Duplicador</h1>
                    <p className="rk-head__subtitle">
                        Copia módulos, submódulos y formatos —con sus subformularios, PDFs, fórmulas y permisos— dentro de la misma empresa o a otra. Cada copia se verifica y se puede deshacer.
                    </p>
                </div>
                <div className="rk-head__actions">
                    <button type="button" className={`rk-head__btn ${view === "wizard" ? "rk-head__btn--primary" : "rk-head__btn--ghost"}`} onClick={newCopy}>
                        <i className="fas fa-plus"></i> Nueva copia
                    </button>
                    <button type="button" className={`rk-head__btn ${view === "history" ? "rk-head__btn--primary" : "rk-head__btn--ghost"}`} onClick={() => setView("history")}>
                        <i className="fas fa-history"></i> Historial
                    </button>
                </div>
            </div>

            {view === "wizard" && <Wizard key={wizardKey} onLaunched={openRun} />}
            {view === "history" && <History onOpen={openRun} />}
            {view === "run" && runId && (
                <RunView key={runId} id={runId} onOpen={openRun} onBack={() => setView("history")} />
            )}
        </div>
    );
};

export default Index;
